export const news = {
  newsFeedCreateInputPlaceholder: 'Escribe una publicación...',
  newsFeedSearchInputPlaceholder: 'Buscar',
  newsFeedPostOwnerCurtainEditTitle: 'Editar publicación',
  newsFeedPostOwnerCurtainDeleteTitle: 'Eliminar publicación',
  newsFeedEditedPostSavedAlertText: '¡Publicación guardada!',
  newsFeedEditedPostDeletedAlertText: '¡Publicación eliminada!',
  newsFeedShareCurtainOptionTitle: 'Copiar enlace',
  newsFeedPostLinkCopiedAlertText: '¡Enlace copiado!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Copiar enlace',
  newsFeedOthersPosLinkCopiedAlertText: '¡Enlace copiado!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Marcar contenido',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Eliminar publicación',
  newsFeedPostDeletePopupTitle: 'Eliminar',
  newsFeedPostDeletePopupText: '¿Estás seguro de que quieres eliminar esta publicación?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Cancelar',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Confirmar',
  newsFeedPostDeeletedAlertText: '¡Publicación eliminada!',
  newsPostDetailsHeaderTitle: 'Publicación',
  postFeedPostLikesText: 'Me gusta',
  postFeedPostCommentsText: 'Comentarios',
  postFeedPostNoLikesText: 'Todavía no hay Me gusta',
  postFeedPostLeaveFirstLikeText: 'Puedes ser el primero en dar Me gusta',
  newsFeedPostDetailsNoCommentsText: 'Todavía no hay comentarios',
  newsFeedPostDetailsFirstCommentText: 'Puedes ser el primero en comentar',
  newsFeedPostDetailsShareOptionTitle: 'Copiar enlace',
  newsFeedPostDetailsSharePostCopiedAlertText: '¡Enlace copiado!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copiar enlace',
  newsFeedPostDetailsCopiedAlertText: '¡Enlace copiado!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Marcar contenido',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Marcar como spam',
  newsPostDetailsReportedCurtainText: 'Contenido marcado',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Editar comentario',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Eliminar comentario',
  newsPostDetailsEditedCommentSavedAlertText: '¡Comentario guardado!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Eliminar comentario',
  postDetailsOtherUsersCommentDeletadAlertText: '¡Comentario eliminado!',
  postDetailsDeleteCommentPopupTitle: 'Eliminar',
  postDetailsDeleteCommentPopupText: '¿Estás seguro de que quieres eliminar este comentario?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  postDetailsCommDeletedAlertText: '¡Comentario eliminado!',
  postDetailsCommentUserCurtainOptionTitle: 'Marcar comentario',
  newsCreatePostCurtainTitle: 'Nueva publicación',
  newsCreatePostCurtainBodyPlaceholder: 'Escribe tu publicación aquí...',
  newsCreatePostPublishButtonTitle: 'Publicar',
  newsCreatePostUploadSlallerImageAlertText: 'Solo puedes subir hasta {size} MB a la vez',
  newsPostSavedAlertText: '¡Publicación guardada!',
  newsCreatePostAddLocationCurtainTitle: 'Ubicación',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Nombre de la ubicación',
  newsCreatePostEditLocationCurtainText: 'Editar ubicación',
  newsDeleteLocation: 'Eliminar ubicación',
  newsDiscardPostPopupTitle: 'Borrador',
  newsDiscardPostPopupText: '¿Descartar este borrador?',
  newsDiscardPostPopupCancelButtonTitle: 'Cancelar',
  newsDiscardPostPopupCofirmButtonTitle: 'Confirmar',
  newsNewPostCreatePollTitle: 'Crear encuesta',
  newsNewPostCreatePollTitleInputPlaceholder: 'Título',
  newsNewPostCreatePollOptionInputPlaceholder: 'Opción',
  newsNewPostCreatePollAddButtonTitle: 'Agregar opción',
  newsNewPostCreatePollCreateButtonTitle: 'Crear',
  newsCreatePostPollTitleBlankAlertText: 'El título no puede estar en blanco!',
  newsCreatePostPollOptionBlankAlertText: 'La opción no puede estar en blanco!',
  newsCreatePostPollLongTitleAlertText: 'El título puede contener como máximo {length} caracteres',
  newsCreatePostPollLongOptionAlertText: 'La opción puede contener como máximo {length} caracteres',
  newsCreatePostPollEditOptionTitle: 'Editar encuesta',
  newsCreatePostPollRemoveOptionTitle: 'Eliminar encuesta',
  newsPostPollInfoVotesText: 'votos',
  newsPostPollInfoEditVoteText: 'Editar voto',
  newsPostPollFinishPollText: 'Finalizar encuesta',
  newsPostPollFinishedPollText: 'Finalizada',
  newsPostPollInProgresslText: 'En progreso',
  newsFinishPollCurtainTitle: 'Finalizar encuesta',
  newsFinishPollCurtainText: 'Los usuarios no podrán votar después de que se finalice la encuesta.',
  newsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  newsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  newsPollInfoPollVotesCurtainTitle: 'Votos de la encuesta',
  newsEditPostCurtainTitle: 'Editar publicación',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Escribe tu publicación aquí...',
  newsEditPostCurtainSaveButtonTitle: 'Guardar',
  newsEditPostSavedAlertText: '¡Publicación guardada!',
  newsError: '¡Algo salió mal!',
  newsAt: 'a las',
  newsSeeMore: 'Ver más...',
  newsMaxAttachments: 'Has superado el número máximo de adjuntos. El máximo de adjuntos es {length}',
  newsReply: 'Responder',
  newsPin: 'Fijar publicación',
  newsUnpin: 'Desfijar publicación'
}
